import AttributeValidator from './AttributeValidator';
import AttributeResolver from './AttributeResolver';
import { Types } from '../V4/Attribute';
import * as Errors from './Errors';
import pkg from '../../package.json';

// exporting external interface to V5 Product Rules Engine.
module.exports = {
  validate: AttributeValidator.validate,
  resolve: AttributeResolver.resolve,
  AttributeTypes: Types,
  Version: pkg.version,
  Errors,
};
